export default __webpack_public_path__ + "static/media/multiplechoice-challenge.f1b22423.png";